import React, { useState, useEffect } from "react"
import { Input, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { t } from "@lingui/macro"
import PropTypes from "prop-types"

const formStyle = {
  flex: "10",
  padding: "5px",
  fontFamily: "Fira Sans",
  fontSize: "20px",
  height: "50px",
}

const CustomModal = (props) => {
  const {
    className,
    headerClassName,
    isOpen,
    isCentered,
    showInput,
    showSavingsCycle,
    isCashoutModal,
    inputPlaceholder,
    cycleDuration,
    getNewCycleData,
    setInputData,
    isDisabled,
    modalHeader,
    bodyContent,
    errors,
    footerContent,
  } = props

  const [modal, setModal] = useState(isOpen)
  const [state, setState] = useState({
    inputNumber: inputPlaceholder,
    cycleDuration: cycleDuration,
  })

  useEffect(() => {
    setModal(isOpen)
    setState({ ...state, inputNumber: inputPlaceholder })
  }, [isOpen, inputPlaceholder])

  const onChange = (e) => {
    const { name, value } = e.target
    if (isCashoutModal && value.length > value.trim().length) return
    setState({ ...state, [name]: value })
  }

  useEffect(() => {
    if (!showInput || isCashoutModal) return
    getNewCycleData(state)
  }, [state, showInput, isCashoutModal])

  useEffect(() => {
    if (!isCashoutModal) return
    setInputData(state.inputNumber)
  }, [state, isCashoutModal])

  return (
    <div>
      <Modal
        centered={isCentered}
        isOpen={modal}
        className={className}
      >
        <ModalHeader className={headerClassName}>{modalHeader}</ModalHeader>
        <ModalBody>
          {bodyContent}
          {showInput && (
            <>
              <br />
              <span style={{ color: "red" }}>{errors.amount}</span>
              <Input
                type={isCashoutModal ? "text" : "number"}
                disabled={isDisabled}
                name="inputNumber"
                value={state.inputNumber}
                onChange={onChange}
                placeholder={isCashoutModal ? t({ id: "Write here" }) : ""}
              />
              <br />
              {showSavingsCycle && (
                <Input
                  disabled={isDisabled}
                  id="savings_cycle"
                  type="select"
                  name="cycleDuration"
                  style={formStyle}
                  onChange={onChange}
                  value={state.cycleDuration}
                >
                  <option value="">{t({ id: "Savings Cycle" })}</option>
                  <option value="6">{t({ id: "6 Months" })}</option>
                  <option value="9">{t({ id: "9 Months" })}</option>
                  <option value="12">{t({ id: "1 Year" })}</option>
                </Input>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter>{footerContent}</ModalFooter>
      </Modal>
    </div>
  )
}

CustomModal.propTypes = {
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  isOpen: PropTypes.bool,
  isCentered: PropTypes.bool,
  showInput: PropTypes.bool,
  showSavingsCycle: PropTypes.bool,
  isCashoutModal: PropTypes.bool,
  inputPlaceholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  cycleDuration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  getNewCycleData: PropTypes.func,
  setInputData: PropTypes.func,
  isDisabled: PropTypes.bool,
  modalHeader: PropTypes.string,
  bodyContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  errors: PropTypes.object,
  footerContent: PropTypes.object,
}

export default CustomModal
